//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  name: 'vue-good-wizard',

  props: {
    steps: {},
    previousStepLabel: {default: 'Back'},
    nextStepLabel: {default: 'Next'},
    finalStepLabel: {default: 'Save'},
    onNext: {},
    onBack: {}
  },

  watch: {
    steps: {
      handler () {
        this.parseOptions()
      },
      immediate: true
    }
  },

  data () {
    return {
      currentStep: 0,
      isMounted: false,
      resizer: null,
      isMobile: false,
      options: []
    }
  },
  computed: {
    wizardStepStyle () {
      if (this.isMobile) {
        return {
          width: '100%'
        }
      }

      return {
        width: `${100 / this.steps.length}%`
      }
    },
    mobileArrowPosition () {
      return 'calc(50% - 14px)'
    },
    arrowPosition () {
      if (this.isMobile) {
        return this.mobileArrowPosition
      }
      var stepSize = 100 / this.steps.length
      var currentStepStart = stepSize * this.currentStep
      var currentStepMiddle = currentStepStart + (stepSize / 2)
      if (this.steps.length === 1) { return 'calc(' + currentStepMiddle + '%)' } else { return 'calc(' + currentStepMiddle + '% - 14px)' }
    },
    currentSlot () {
      return this.steps[this.currentStep].slot
    },
    backEnabled () {
      return this.currentStep !== 0
    }
  },
  methods: {
    goNext (skipFunction) {
      if (!skipFunction && typeof this.onNext === 'function') {
        if (!this.onNext(this.currentStep)) {
          // returned false. don't do anything
          return
        }
      }
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++
      }
    },
    goBack (skipFunction) {
      if (!skipFunction && typeof this.onBack === 'function') {
        if (!this.onBack(this.currentStep)) {
          // returned false. don't do anything
          return
        }
      }
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },

    goTo (step) {
      if (Number.isInteger(step) &&
        step < this.steps.length &&
        step >= 0) {
        this.currentStep = step
      }
    },

    parseOptions () {
      this.options = []
      for (let i = 0; i < this.steps.length; i++) {
        this.options.push(this.steps[i].options ? this.steps[i].options : {})
      }
    },

    handleResize () {
      console.log('handle resize')
      if (this.resizer) {
        clearTimeout(this.resizer)
      }
      this.resizer = setTimeout(() => {
        console.log('resizing...')
        this.isMobile = this.$refs['wizard-body'].clientWidth < 1620
      }, 100)
    }
  },
  mounted () {
    this.isMobile = this.$refs['wizard-body'].clientWidth < 1620
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Wizard.vue